import { format } from 'date-fns';

import { cn } from '@elara/client-core/lib/utils';

/**
 * The full-width "Day N" banner that opens each day of the full-page itinerary. Purely
 * presentational, shared by the owner's itinerary and the public shared itinerary.
 */
export function DayHeader({
  number,
  date,
  title,
  titleLoading,
}: {
  number: number;
  date: Date;
  title?: string;
  /** When true, show a skeleton in place of the title (e.g. while day summaries are generating). */
  titleLoading?: boolean;
}) {
  return (
    <div
      data-print="day-header"
      className="flex flex-col md:items-center gap-2 w-full py-8 md:py-24 border-b bg-background-secondary px-4 md:px-8"
    >
      <div className="uppercase tracking-wide font-medium text-sm">Day {number}</div>
      {titleLoading ? (
        <div className="h-8 w-48 rounded-md animate-pulse bg-camel-100" aria-busy="true" />
      ) : (
        title && <div className={cn('text-xl md:text-2xl font-display')}>{title}</div>
      )}
      <div className="text-muted-foreground text-sm">{format(date, 'EEEE, MMM d')}</div>
    </div>
  );
}
